module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0071.jpg?v=838150af";